module.exports = __webpack_public_path__ + "static/media/Scribble.ffddc704.svg";